import React from 'react'

function PageItem(props) {
  if (props.disabled === true) {
    return (
      <li className="page-item disabled"><span className="page-link">{ props.label }</span></li>
    )
  }
  
  return (
    <li className="page-item"><span className="page-link" onClick={() => {props.onClick()}}>{ props.label }</span></li>
  )
}

export default PageItem